import { SVGProps, Ref, forwardRef } from 'react';

export const SquareCircleFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 .5c6.563 0 7.5.938 7.5 7.5s-.937 7.5-7.5 7.5S.5 14.563.5 8 1.438.5 8 .5M8 4C5 4 4 6 4 8s1 4 4 4 4-2 4-4-1-4-4-4"
                fill="currentColor"
            />
        </g>
    </svg>
));
SquareCircleFilledSize16Glyph.displayName = 'SquareCircleFilledSize16Glyph';
